import {useEffect, useState} from 'react'
import {useTranslation} from 'react-i18next'
import RecommendedPromotion from './RecommendedPromotion'

type IProps = {
 hidePartent: boolean
 setHideParent: (newState: boolean) => void
}

const PromotionScreen = (props: IProps) => {
 const {t} = useTranslation()
 const [selectedTab, setSelectedTab] = useState<
  'recommended' | 'custom'
 >('recommended')

 useEffect(() => {
  props.setHideParent(false)
 }, [])

 return (
  <>
   <p
    style={{
     fontSize: 24,
     fontWeight: '700',
     marginBottom: 24,
    }}
   >
    {t('productPromotion.title')}
   </p>
   <div className='flex items-center gap-8 border-b border-[#E6EBF0] mb-6'>
    <div
     className={`pb-2 cursor-pointer text-sm font-semibold ${
      selectedTab === 'recommended'
       ? 'text-[#4E83E4] border-b-2 border-[#4E83E4]'
       : 'text-[#5A6066]'
     }`}
     onClick={() => setSelectedTab('recommended')}
    >
     {t('productPromotion.recommendedMessages')}
    </div>

    {/* <div
     className={`pb-2 cursor-pointer text-sm font-semibold ${
      selectedTab === 'custom'
       ? 'text-[#4E83E4] border-b-2 border-[#4E83E4]'
       : 'text-[#5A6066]'
     }`}
     onClick={() => setSelectedTab('custom')}
    >
     {t('productPromotion.customMessages')}
    </div> */}
   </div>
   {selectedTab === 'recommended' && (
    <RecommendedPromotion />
   )}
   {selectedTab === 'custom' && (
    <>{/* <CustomMessage /> */}</>
   )}
  </>
 )
}

export default PromotionScreen
